// "Zobacz" side panels on the season news list. Follows lightbox.js: native
// <dialog> + showModal for focus trapping, Esc and the backdrop; clicks are
// delegated so panels added by later renders keep working. Focus returns to
// the trigger when a panel closes, and the body scroll is locked while one
// is open (the modal dialog itself still scrolls).
export function initSeasonNews() {
  const sheets = [...document.querySelectorAll(".cms-season-news__sheet")];
  if (!sheets.length) return;

  const triggers = new Map();
  let openCount = 0;

  function setScrollLocked(locked) {
    document.documentElement.classList.toggle("cms-modal-open", locked);
  }

  document.addEventListener("click", (event) => {
    const openButton = event.target.closest("[data-season-news-open]");
    if (openButton) {
      const sheet = document.getElementById(openButton.getAttribute("aria-controls"));
      if (!sheet) return;
      triggers.set(sheet, openButton);
      openCount += 1;
      setScrollLocked(true);
      sheet.showModal();
      return;
    }

    const closeButton = event.target.closest("[data-season-news-close]");
    if (closeButton) closeButton.closest("dialog")?.close();
  });

  sheets.forEach((sheet) => {
    sheet.addEventListener("click", (event) => {
      // A click on the dimmed backdrop lands on the dialog element itself.
      if (event.target === sheet) sheet.close();
    });

    sheet.addEventListener("close", () => {
      openCount = Math.max(0, openCount - 1);
      if (openCount === 0) setScrollLocked(false);
      const trigger = triggers.get(sheet);
      if (trigger) {
        trigger.focus();
        triggers.delete(sheet);
      }
    });
  });
}
